// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"c1bce1ea","319":"1576bd0d","499":"acf9a84d","747":"3a7802a6","842":"fb63ba32"}[chunkId] + ".chunk.js";
};